import { render, staticRenderFns } from "./detail-edit-dialog.vue?vue&type=template&id=5daf8022&"
import script from "./detail-edit-dialog.vue?vue&type=script&lang=js&"
export * from "./detail-edit-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports